module.exports = __webpack_public_path__ + "static/foto1-9cfaed3f36999eae6222808cfe08dd80.jpg";